import NativeLink from 'next/link';
import React from 'react';

export default function Link(props) {
  const {
    children,
    href,
    passHref,
  } = props;
  // const { i18n } = useTranslation();
  const linkProps = {
    ...props,
    passHref: passHref ?? true,
  };

  if (linkProps.href === '#') {
    linkProps.href = {
      pathname: '#',
    };
  }

  return (
    <NativeLink
      href={href ?? '#'}
      legacyBehavior
      {...linkProps}
    >
      {children}
    </NativeLink>
  );
}

Link.propTypes = {
  ...NativeLink.propTypes,
};
